import type { FaireProductEntity } from "../../entity_types/product";

export const p_49xygbydt5: FaireProductEntity = {
  token: "p_49xygbydt5",
  type: "product",
  name: "D967-V929",
  brandToken: "b_7zkdvevji4",
  brandName: "Ariella USA",
  imageUrl:
    "https://cdn.faire.com/fastly/a37bb8112a02ac9dde703e001141a194015a0ae92b5ff7e1f25e885b1dcd51dd.png",
  galleryImageUrls: [],
  priceDollars: 210,
  description:
    "Elevate your everyday style with this stunning sleeveless midi dress! Featuring a captivating abstract print in a sophisticated black and beige palette, this dress offers a modern and chic aesthetic. The V-neckline is beautifully complemented by a flattering ruched detail at the bodice, creating a graceful silhouette that accentuates your figure. Crafted from a lightweight, flowy fabric, it ensures comfort and effortless movement, making it perfect for any casual occasion. Whether you're heading out for a brunch date, a leisurely stroll, or a summer gathering, this versatile dress promises to keep you looking stylish and feeling fabulous. Pair it with sandals or heels to transition seamlessly from day to night. This is a must-have addition to your warm-weather wardrobe!",
  tags: [],
  msrpDollars: 630,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:50.815Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
